import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function IssuesIcon(props: ACIconProps) {
  return <ACIconWrapper {...props} component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00008 7.99999C8.36827 7.99999 8.66675 8.29847 8.66675 8.66666V9.99999C8.66675 10.3682 8.36827 10.6667 8.00008 10.6667C7.63189 10.6667 7.33341 10.3682 7.33341 9.99999V8.66666C7.33341 8.29847 7.63189 7.99999 8.00008 7.99999Z"
        fill="currentColor"
      />
      <path
        d="M8.00008 6.66666C8.36827 6.66666 8.66675 6.36818 8.66675 5.99999C8.66675 5.6318 8.36827 5.33332 8.00008 5.33332C7.63189 5.33332 7.33341 5.6318 7.33341 5.99999C7.33341 6.36818 7.63189 6.66666 8.00008 6.66666Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00008 3.66666C5.60685 3.66666 3.66675 5.60676 3.66675 7.99999C3.66675 10.3932 5.60685 12.3333 8.00008 12.3333C10.3933 12.3333 12.3334 10.3932 12.3334 7.99999C12.3334 5.60676 10.3933 3.66666 8.00008 3.66666ZM2.66675 7.99999C2.66675 5.05447 5.05456 2.66666 8.00008 2.66666C10.9456 2.66666 13.3334 5.05447 13.3334 7.99999C13.3334 10.9455 10.9456 13.3333 8.00008 13.3333C5.05456 13.3333 2.66675 10.9455 2.66675 7.99999Z"
        fill="currentColor"
      />
    </svg>
  );
};
